import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Resets the window scroll to top whenever the route changes. */
export default function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    // Use "auto" so it doesn't animate on route change
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, search]);
  return null;
}
